type LoatTypeInfo = {
    title: string;
};

export const loanTypesMap: Record<string, LoatTypeInfo> = {
    FIXED_TERM: {
        title: 'fixedTerm',
    },
    CREDIT_LINE: {
        title: 'creditLine',
    },
};

export const loanTypeOptions = Object.entries(loanTypesMap).map(
    ([key, info]) => {
        return {
            id: key,
            title: info.title,
            'data-testid': `loan-type-${key}`,
        };
    },
);
